import { useEffect, useContext, useState } from "react";
import { Button, Card, Skeleton } from "antd";
import HTTP from "../../services/httpService";
import { SettingContext } from "../../routes";
import CustomHeader from "../common/Header";
import { useNavigate } from "react-router-dom";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import moment from "moment";

function TransactionDurationTable() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();

    const {
        selectedDates,
        setSingleSelectedHotels,
        selectedHotels,
        kioskSelection,
    } = useContext(SettingContext);

    const hotel_ids = selectedHotels;

    const [start_date, end_date] = selectedDates;

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "transaction_time",
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        calling_hotel_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: transactionDurationStatus,
        data: transactionDurationRes,
        refetch: fetchTransactionDuration,
    } = useQuery(
        "transactionDurationTable",
        async () => {
            return await HTTP("/dashboard/getTransactionData", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchTransactionDuration();
    }, []);

    useEffect(() => {
        fetchTransactionDuration();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (transactionDurationStatus === "success") {
            const { data: transactionData, total } = transactionDurationRes;
            setTotalRecords(total);
            setTableData(transactionData);
        }
    }, [transactionDurationStatus, transactionDurationRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ order, columnKey });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            render: (text, record) => (
                <span
                    onClick={getTransactionDurationGraph}
                    id={record.hotel_id}
                    data-hotelname={text}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Transaction ID ",
            dataIndex: "transaction_id",
            key: "transaction_id",
            render: (text, record) => (
                <span
                    onClick={getTransactionDetails}
                    id={record.transaction_id}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "transaction_id"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Transaction Time ",
            dataIndex: "transaction_time",
            key: "transaction_time",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "transaction_time"
                    ? sortedInfo.order
                    : null,
        },
    ];

    function getTransactionDurationGraph(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        const hotel_name = e.currentTarget.getAttribute("data-hotelname");
        setSingleSelectedHotels(`${hotel_name}#${hotel_id}`);
        return navigate(`/transaction-duration-graph/${hotel_id}`);
    }

    function getTransactionDetails(e) {
        const operation_id = e.currentTarget.getAttribute("id");
        return navigate("/operation-details", { state: { operation_id } });
    }

    async function downloadFile() {
        let { start_date, end_date, all_selected, hotel_ids } = formData;
        start_date = moment(start_date).format(`YYYY-MM-DD`);
        end_date = moment(end_date).format(`YYYY-MM-DD`);
        let url = `/dashboard/getTransactionDataReport?start_date=${start_date}&end_date=${end_date}&hotel_ids=${
            hotel_ids.length === 0 ? `[]` : `[${hotel_ids.join()}]`
        }&staff_id=${staff_id}&all_selected=${all_selected}`;
        const res = await HTTP(url, {}, "GET");
        downloadCSV(res, "Transaction");
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            className="margin-right-5"
                            type="primary"
                            disabled={totalRecords === 0}
                            onClick={downloadFile}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {transactionDurationStatus === "loading" ||
                transactionDurationStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="transaction_id"
                        className="review-table"
                    />
                )}
            </Card>
        </Card>
    );
}

export { TransactionDurationTable };
